<template>
<div class="layerbook-wrap" v-if="visible" @click.self="handleWrapperClick">
    <div class="target-book layerbook">
        <div class="layerbook-header">
            <h3 class="title">고객주소록</h3>
            <button type="button" class="layerbook-close" @click="handleWrapperClick" aria-label="닫기">
                <IconBack />
            </button>
        </div>
        <div class="layerbook-body container">
            <div class="layerbook-filter">
                <div class="filter-item">
                    <select name="" id="" class="form-control">
                        <option value="전체" selected>전체</option>
                        <option value="항목">항목</option>
                        <option value="전화번호">전화번호</option>
                        <option value="이름">이름</option>
                    </select>
                    <input type="text" class="form-control">
                    <button type="button" class="btn btn-sm">확인</button>
                </div>
            </div>
            <div class="layerbook-data">
                <ul id="accordion">
                    <li>
                        <div class="layerbook-data-list">
                            <label class="radio"><input type="radio" id="allCheck" name=""></label>
                            <span>항목</span>
                            <span>전화번호</span>
                            <span>이름</span>
                        </div>
                    </li>
                    <!-- 데이터 0일 때 -->
                    <!-- <li>
                        <div class="layerbook-data-list">
                            저장된 데이터가 없습니다.
                        </div>
                    </li> -->
                    <!-- 데이터 1 이상일 때 -->
                    <li>
                        <div class="layerbook-data-list" id="aacordianItem01">
                            <label class="radio"><input type="radio" id="" name=""></label>
                            <span><span class="target-item">6월 VIP고객</span></span>
                            <span>010-1234-5678</span>
                            <a class="themore-link" data-bs-toggle="collapse" href="#target01" role="button" aria-expanded="false" aria-controls="target01">김OO</a>
                        </div>
                        <div class="layerbook-data-detail collapse" id="target01" aria-labelledby="aacordianItem01" data-bs-parent="#accordion">
                            <div class="card card-body">
                                그룹:6월 VIP고객<br> 이름: 김OO<br>번호: 010-1234-5678<br>비고: 
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="layerbook-data-list">
                            <label class="radio"><input type="radio" id="" name=""></label>
                            <span><span class="target-item">제휴사</span></span>
                            <span>010-1234-5678</span>
                            <a class="themore-link" data-bs-toggle="collapse" href="#target02" role="button" aria-expanded="false" aria-controls="target02">김OO</a>
                        </div>
                        <div class="layerbook-data-detail collapse" id="target02" data-bs-parent="#accordion">
                            <div class="card card-body">
                                그룹:6월 VIP고객<br> 이름: 김OO<br>번호: 010-1234-5678<br>비고: 
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="layerbook-data-list">
                            <label class="radio"><input type="radio" id="" name=""></label>
                            <span><span class="target-item">제휴사</span></span>
                            <span>010-1234-5678</span>
                            <a class="themore-link" data-bs-toggle="collapse" href="#target03" role="button" aria-expanded="false" aria-controls="target03">김OO</a>
                        </div>
                        <div class="layerbook-data-detail collapse" id="target03" data-bs-parent="#accordion">
                            <div class="card card-body">
                                그룹:6월 VIP고객<br> 이름: 김OO<br>번호: 010-1234-5678<br>비고: 
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="layerbook-data-list">
                            <label class="radio"><input type="radio" id="" name=""></label>
                            <span><span class="target-item">제휴사</span></span>
                            <span>010-1234-5678</span>
                            <a class="themore-link" data-bs-toggle="collapse" href="#target04" role="button" aria-expanded="false" aria-controls="target04">김OO</a>
                        </div>
                        <div class="layerbook-data-detail collapse" id="target04" data-bs-parent="#accordion">
                            <div class="card card-body">
                                그룹:6월 VIP고객<br> 이름: 김OO<br>번호: 010-1234-5678<br>비고: 
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="layerbook-btns">
                <button type="button" class="btn btn-sm">등록</button>
                <button type="button" class="btn btn-sm">삭제</button>
            </div>            
        </div>
        <!-- <div class="layerbook-footer">
            <button type="button" class="layerbook-submit btn btn-lg btn-primary">추가하기</button>
        </div> -->
    </div>
</div>
</template>

<script>
export default {
    name: 'target-book',
    
    components: {
        IconBack: () => import('@/components/svg-icon/IconBack.vue'),   // 뒤로가기 아이콘
    },

    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
        title: {
            type: String,
            require: false,
        },
    },

    methods: {
        handleWrapperClick() {
            this.$emit('update:visible', false)
        },
    },
}
</script>

<style lang="scss" scoped>

@import '@/assets/css/order.scss';
@import '@/assets/css/layerpopup.scss';

.layerbook-data-list{
    >*:not(:first-child) {
        width: 33%;
    }
}
</style>